export const OAUTH_PROVIDERS = {
  google: "GoogleOAuth",
  microsoft: "MicrosoftOAuth",
  apple: "AppleOAuth",
  linkedin: "LinkedInOAuth",
} as const;

export type OAuthProviderSlug = keyof typeof OAUTH_PROVIDERS;

export const SIGN_IN_PARAM = "signIn";

function isProviderSlug(value: string): value is OAuthProviderSlug {
  return Object.prototype.hasOwnProperty.call(OAUTH_PROVIDERS, value);
}

export function parseProvider(value: string | null): OAuthProviderSlug | null {
  return value && isProviderSlug(value) ? value : null;
}
